import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddressForm from './AddressForm';
import Invoices from './Invoices';
import { Tab, Tabs } from 'material-ui/Tabs';

import api from '../../../utils/api';
import { Col, Row } from 'react-flexbox-grid';
import { addressSelector } from '../selectors';
import LinearProgress from 'material-ui/LinearProgress';

class AccountView extends Component {
    submitHandler = values => {
        this.props.update({ account: values.toJS() });
    };

    componentDidMount = () => {
        this.props.get();
    };

    render() {
        const styles = {
            headline: {
                fontSize: 24,
                paddingTop: 16,
                marginBottom: 12,
                fontWeight: 400,
            },
        };

        return (
            <div>
                {this.props.isFetching && (
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <LinearProgress
                                mode="indeterminate"
                                color="#3babd0"
                                style={{
                                    left: '0px',
                                    height: '10px',
                                    top: '63px',
                                    right: '0px',
                                    position: 'absolute',
                                }}
                            />
                        </Col>
                    </Row>
                )}
                <Tabs>
                    <Tab label="Rechnungsadresse">
                        <div style={{ padding: '20px' }}>
                            <Row>
                                <Col md={5} sm={12} xs={12}>
                                    <AddressForm
                                        onSubmit={this.submitHandler}
                                        initialValues={this.props.address}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Tab>
                    <Tab label="Rechnungen">
                        <div style={{ padding: '20px' }}>
                            <Invoices />
                        </div>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    isFetching: state.account.get('isFetching'),
    address: addressSelector(state),
});

const mapDispatchToProps = dispatch => ({
    update: payload => dispatch(api.actions.account.update(payload)),
    get: payload => dispatch(api.actions.account.get(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountView);
